import React, { useEffect, useState } from 'react';

import { ValueBox, ValueBoxGroupOptions, ValueStepper } from '@candu-ai/craft/ui';
import { getCssResetStyleMessage, StylesHierarchy } from 'craft/hooks';
import { useViewportBreakpoint } from 'craft/state';

interface Props {
  cssProps: Record<string, unknown>;
  setCss: (e: Record<string, unknown>) => void;
  variant: string;
  stylesHierarchy: StylesHierarchy;
  isInGroup?: ValueBoxGroupOptions;
}

export const LetterSpacing = ({ cssProps, setCss, isInGroup, stylesHierarchy, variant }: Props) => {
  const { letterSpacing } = cssProps;
  const viewport = useViewportBreakpoint();

  const defaultValue = parseFloat((stylesHierarchy?.letterSpacing?.fallbackValue || '') as string);
  const [inputValue, setInputValue] = useState<number | undefined>(
    letterSpacing ? parseFloat(letterSpacing as string) : defaultValue,
  );

  useEffect(() => {
    setInputValue(letterSpacing ? parseFloat(letterSpacing as string) : defaultValue);
  }, [variant, viewport]);

  return (
    <ValueBox label="Letter Spacing" isInGroup={isInGroup}>
      <ValueStepper
        scale="small"
        editable
        minValue={0}
        maxValue={999}
        step={1}
        onResetTooltip={getCssResetStyleMessage(stylesHierarchy?.letterSpacing?.fallbackStyle)}
        onReset={
          !!letterSpacing && inputValue !== defaultValue
            ? () => {
                setInputValue(defaultValue);
                setCss({ letterSpacing: undefined });
              }
            : undefined
        }
        onBlur={() => {
          if (typeof inputValue === 'undefined') {
            setInputValue(defaultValue);
          }
        }}
        onChange={(newValue?: number) => {
          setInputValue(newValue);
          if (newValue === defaultValue) {
            setCss({ letterSpacing: undefined });
            return;
          }
          // only trigger change when there is no value or the value is within the accepted range
          if (typeof newValue === 'undefined' || (newValue >= 0 && newValue <= 999)) {
            setCss({ letterSpacing: typeof newValue !== 'undefined' ? `${newValue}px` : newValue });
          }
        }}
        valueSuffix="px"
        value={inputValue}
      />
    </ValueBox>
  );
};
